import React from 'react'
import { connect } from 'react-redux'
import {
  ACCOUNT_GO,
  ACCOUNT_SEARCH
} from '../constants/actionTypes'
import agent from '../agent';

const mapStateToProps = state => ({ ...state.account })

const mapDispatchToProps = dispatch => ({
  onRedirect: (payload, raw) => {
    dispatch({ type: ACCOUNT_GO, payload, raw })
  },
  onSearchAccount: (payload) => {
    dispatch({ type: ACCOUNT_SEARCH, payload })
  }
})

class Accounts extends React.Component {
  constructor() {
    super()
    this.state = {
      keyword: ''
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    };
    this.redirect = (accountKey) => ev => {
      ev.preventDefault()
      this.props.onRedirect(accountKey)
    }
    this.searchAccount = (keyword) => ev => {
      ev.preventDefault()
      let payload = agent.Accounts.findAccountByKeyOrExternal(keyword)
      this.props.onSearchAccount(payload)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.account) {
      if (nextProps.account.key) {
        this.props.onRedirect(nextProps.account.key, false)
      } else {
        this.props.onRedirect(nextProps.account.publickey, true)
      }

    } else {
      this.setState({ message: 'No account found.' })
    }
  }

  render() {

    const keyword = this.state.keyword

    return (
      <div class='pane'>
        <h1>Find Account</h1>
        <div className="search">
          <form onSubmit={this.searchAccount(keyword)}>
            <input type="text" value={keyword} onChange={this.updateState('keyword')} placeholder="account id" />
            <button type="submit">Go to account</button>
            <div className="form-group">
              {this.state.message}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Accounts)



// WEBPACK FOOTER //
// ./src/components/Accounts.js